<template>
  <svg
    width="14px"
    height="14px"
    viewBox="0 0 14 14"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink">
    <!-- Generator: Sketch Beta 52.3 (67297) - http://www.bohemiancoding.com/sketch -->
    <title>MerchandiseIcon</title>
    <desc>Created with Sketch Beta.</desc>
    <g
      id="merchandise-icon"
      stroke="none"
      stroke-width="1"
      fill="none"
      fill-rule="evenodd">
      <!-- eslint-disable max-len -->
      <polygon
        id="Path"
        class="override-fill"
        stroke="none"
        fill="none"
        fill-rule="nonzero"
        points="9.01852103 2 12 2 12 13 2 13 2 2 5.21923892 2 5.21923892 3.05311169 9.01852103 3.05311169"/>
      <!-- eslint-enable max-len -->
      <rect
        id="Rectangle"
        class="override-fill"
        stroke="none"
        fill-rule="nonzero"
        x="5"
        y="1"
        width="4"
        height="2"/>
      <polyline
        id="merchandise-icon-check"
        stroke="none"
        fill-rule="nonzero"
        points="4.5 7.82971016 6.12645628 9.57056943 9.45098838 6.5"/>
    </g>
  </svg>
</template>

<script>
export default {
  name: 'MerchandiseIcon',
}
</script>



// WEBPACK FOOTER //
// src/components/navigation/icons/MerchandiseIcon.vue